var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("详情"),
      visible: _vm.visible,
      width: 1200,
      footer: null
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insureDetailInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(item.value) || "-") + " ")])]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("产品信息")))])]), _c("a-table", {
    staticClass: "marginT20 marginB20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      pagination: false,
      "data-source": _vm.productionData,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保信息")))])]), _vm._l(_vm.showForm, function (item, index) {
    return _c("div", {
      key: index
    }, [item.item ? _c("h5", {
      staticStyle: {
        "font-weight": "700",
        "font-size": "14px",
        padding: "0 20px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " ")]) : _vm._e(), _c("a-form-model", {
      attrs: {
        model: {},
        layout: "inline",
        "label-col": {
          span: 7
        },
        "wrapper-col": {
          span: 16
        }
      }
    }, _vm._l(item.item, function (item1, index1) {
      return _c("a-form-model-item", {
        key: index1,
        class: item1.display == "radio" ? "nowrap" : ""
      }, [_c("template", {
        slot: "label"
      }, [_vm._v(" " + _vm._s(_vm.$t(item1.name)) + " ")]), item1.valData1 && item1.display == "radio" ? _c("a-radio", {
        attrs: {
          checked: "",
          disabled: ""
        }
      }, [_vm._v(_vm._s(_vm.$t(item1.valData1)))]) : item1.valData1 && item1.display != "radio" ? _c("a-input", {
        attrs: {
          disabled: ""
        },
        model: {
          value: item1.valData1,
          callback: function ($$v) {
            _vm.$set(item1, "valData1", $$v);
          },
          expression: "item1.valData1"
        }
      }) : _c("a-input", {
        attrs: {
          disabled: ""
        },
        model: {
          value: item1.valData,
          callback: function ($$v) {
            _vm.$set(item1, "valData", $$v);
          },
          expression: "item1.valData"
        }
      })], 2);
    }), 1)], 1);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };